module.exports = __webpack_public_path__ + "img/majda.fa75a879.png";